import { useReducer } from 'react';

export function useRerender() {
  const [key, rerender] = useReducer((state: number) => state + 1, 0);
  return [key, rerender] as const;
}
